import React, { FC } from 'react';
import ProfileMenu from '@modules/auth/components/profile/menu/ProfileMenu';

const ProfileMenuPage: FC = () => {
  return <ProfileMenu />;
};

export default ProfileMenuPage;
